import { render, staticRenderFns } from "./EscorterCard.vue?vue&type=template&id=1155e922&scoped=true"
import script from "./EscorterCard.vue?vue&type=script&lang=js"
export * from "./EscorterCard.vue?vue&type=script&lang=js"
import style0 from "./EscorterCard.vue?vue&type=style&index=0&id=1155e922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1155e922",
  null
  
)

export default component.exports